import { t } from '@lingui/core/macro';
import { NumberRangeFilter } from './NumberRangeFilter';
export const renewalTermMonthsFilterLabel = () => t({
    message: 'Renewal term months',
    comment: 'Insights: Renewal term months filter',
});
export function RenewalTermMonthsFilter() {
    return <NumberRangeFilter name="metadataDocumentRenewalTermMonths" label={renewalTermMonthsFilterLabel()}/>;
}
